import { Controller } from "@hotwired/stimulus"

// Toggles date-picker / monthly sections for recurrence types that need extra input.
export default class extends Controller {
  static targets = ["specificDates", "oneOffDate", "monthlyNth"]

  connect() {
    this.toggle()
  }

  toggle() {
    const select = this.element.querySelector("select[name*='[recurrence_type]']")
    if (!select) return

    const type = select.value
    if (this.hasSpecificDatesTarget) {
      this.specificDatesTarget.classList.toggle("hidden", type !== "specific_dates")
    }
    if (this.hasOneOffDateTarget) {
      this.oneOffDateTarget.classList.toggle("hidden", type !== "one_off")
    }
    if (this.hasMonthlyNthTarget) {
      this.monthlyNthTarget.classList.toggle("hidden", type !== "monthly_nth_weekday")
    }
  }
}
